"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const root_1 = __importDefault(require("react-hot-loader/root"));
const errors_1 = require("components/templates/errors");
const auth_1 = __importStar(require("./auth"));
const routes_1 = __importDefault(require("./routes"));
const store_1 = require("store");
const redirect_default_path_1 = __importDefault(require("components/atoms/redirect-default-path"));
const sidebar_1 = __importDefault(require("components/templates/sidebar"));
const constants_1 = require("utils/constants");
const react_redux_1 = require("react-redux");
const app_action_1 = __importDefault(require("./app.action"));
const styles_1 = require("@mui/material/styles");
const modal_1 = require("components/molecules/modal");
const auth_action_1 = __importDefault(require("./auth/auth.action"));
const navbar_1 = __importDefault(require("components/templates/navbar"));
const staticAPI = String(process.env.API_STATIC_ENDPOINT);
const App = () => {
    const location = (0, react_router_dom_1.useLocation)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const kendoCSS = `${staticAPI}/static/css/kendo.css`;
    const kendoDarkCSS = `${staticAPI}/static/css/kendo-dark.css`;
    const { isAuthenticated, defaultPassword, isSuccess, userData } = (0, store_1.useAppSelector)((state) => state.auth);
    const { sidebar, appTheme } = (0, store_1.useAppSelector)((state) => state.app);
    const theme = (0, styles_1.createTheme)({
        palette: {
            mode: appTheme,
        },
    });
    (0, react_1.useEffect)(() => {
        app_action_1.default.manageCache([kendoCSS, kendoDarkCSS]);
    }, []);
    const conditionLogout = location.pathname !== '/login' && !isAuthenticated;
    const styler = (side) => {
        const conditionExpand = side.status === 'expand' && isAuthenticated;
        const conditionColapse = side.status === 'colapse' && isAuthenticated;
        const conditionLogin = location.pathname === '/login' && !isAuthenticated;
        const style = {
            height: `calc(100vh - ${constants_1.navbarStyle.height})`,
            backgroundColor: theme.palette.mode === 'light' ? constants_1.color.semiWhite : constants_1.color.backgroundDark,
            marginTop: constants_1.navbarStyle.height,
            padding: '0 24px',
        };
        if (conditionLogin) {
            style.height = '100vh';
            style.marginTop = 0;
            style.padding = 0;
        }
        if (conditionExpand) {
            style.marginLeft = constants_1.sidebarStyle.menuWidth;
            style.width = `calc(100vw - ${constants_1.sidebarStyle.menuWidth})`;
        }
        if (conditionColapse)
            style.marginLeft = constants_1.sidebarStyle.menuWidthColapse;
        return style;
    };
    (0, react_1.useEffect)(() => {
        dispatch(app_action_1.default.appActionCheckPath({ location, allMenu: sidebar.menu }));
    }, [location.pathname]);
    return ((0, jsx_runtime_1.jsxs)(errors_1.ErrorBoundary, { children: [(0, jsx_runtime_1.jsx)("link", { rel: 'stylesheet', href: theme.palette.mode === 'light' ? kendoCSS : kendoDarkCSS }), conditionLogout && (0, jsx_runtime_1.jsx)(redirect_default_path_1.default, { from: location.pathname, to: '/login' }), (0, jsx_runtime_1.jsxs)(styles_1.ThemeProvider, Object.assign({ theme: theme }, { children: [isAuthenticated && (0, jsx_runtime_1.jsx)(navbar_1.default, { theme: theme.palette.mode, userData: userData }), isAuthenticated && (0, jsx_runtime_1.jsx)(sidebar_1.default, {}), isAuthenticated && defaultPassword && (0, jsx_runtime_1.jsx)(auth_1.PasswordSetup, {}), isSuccess && ((0, jsx_runtime_1.jsx)(modal_1.ModalSuccess, { onClose: () => dispatch(auth_action_1.default.closeError()), messageSuccess: 'Data saved Successfully' })), (0, jsx_runtime_1.jsx)("main", Object.assign({ style: styler(sidebar) }, { children: (0, jsx_runtime_1.jsxs)(react_router_dom_1.Routes, { children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: '/login', element: (0, jsx_runtime_1.jsx)(auth_1.default, {}) }), userData.authorization.length > 0 && (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: '/*', element: (0, jsx_runtime_1.jsx)(routes_1.default, { theme: appTheme }) })] }) }))] }))] }));
};
exports.default = root_1.default.hot(App);
